import { useIntl } from 'react-intl';
import { Tooltip, Typography } from '@rossum/ui/material';

type RowValueProps = {
  value: string | null;
  secondary?: boolean;
};

export const RowValue = ({ value, secondary = false }: RowValueProps) => {
  const intl = useIntl();
  return value ? (
    <Tooltip title={value}>
      <Typography
        variant="body2"
        color={secondary ? 'text.secondary' : 'text.primary'}
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {value}
      </Typography>
    </Tooltip>
  ) : (
    <Typography variant="body2" color="text.disabled">
      {intl.formatMessage({ id: 'features.documentHistory.value.none' })}
    </Typography>
  );
};
